// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type CheckShield48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const CheckShield48: FC<CheckShield48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="m21.8 30.65 11.4-11.4-2.1-2.05-9.15 9.15-5.05-5.05-2.2 2.2 7.1 7.15Zm2.2 13.3c-4.667-1.167-8.5-3.875-11.5-8.125S8 26.917 8 21.85V9.95l16-6 16 6v11.9c0 5.067-1.5 9.725-4.5 13.975S28.667 42.783 24 43.95Zm0-3.1c3.833-1.267 6.958-3.658 9.375-7.175S37 26.217 37 21.85v-9.8l-13-4.9-13 4.9v9.8c0 4.367 1.208 8.308 3.625 11.825 2.417 3.517 5.542 5.908 9.375 7.175Z" />
        </svg>
    );
};

export default CheckShield48;
